import axios from 'axios';
import { getLocalUserID } from './utils';
import env from '../../env';

export const trackPageAnnonymous = async (
  pageName: string,
  properties: Record<string, any> = {},
  partnerID: string
) => {
  const userAgent = navigator.userAgent;
  const userID = getLocalUserID();
  try {
    await axios.post(
      env.api_url +
        `/partners/analytics/Track/p/page?partnerId=${partnerID}&userId=${userID}`,
      {
        Properties: { ...properties, UserAgent: userAgent },
        PageName: pageName,
      }
    );
  } catch {
    // make sure we continue if any errors occur
  }
};

export const trackActionAnnonymous = async (
  actionName: string,
  properties: Record<string, any> = {},
  partnerID: string
) => {
  const userAgent = navigator.userAgent;
  const userID = getLocalUserID();
  try {
    await axios.post(
      env.api_url +
        `/partners/analytics/Track/p/action?partnerId=${partnerID}&userId=${userID}`,
      {
        Properties: { ...properties, UserAgent: userAgent },
        ActionName: actionName,
      }
    );
  } catch {
    // make sure we continue if any errors occur
  }
};
